import React from "react";
import { Link } from "react-router-dom";
import { SideBar } from "./../../sidebar";
import { updateAuction, getAuction } from "../../../../models/auctions";
import swal from "sweetalert";
import i18n from "../../../../i18n";
import { AuctionTabs } from "./../../helper/auction_tabs";
import { Spinner } from "react-bootstrap";
import HeaderBanner from "../../../common/HeaderBanner";
import "../../../../styles/components/create-group.scss";
import {
  ArrowLeft,
  Expand,
  Loader2,
  Plus,
  Shrink,
  Trash2,
} from "lucide-react";

export class AuctionEnquiries extends React.Component {
  constructor(props) {
    super(props);
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);

    this.state = {
      auctionId: auctionId,
      input: {},
      errors: {},
      enquiries: [{ label: "", value: "", label_ar: "", value_ar: "" }],
      details: [{ label: "", value: "", label_ar: "", value_ar: "" }],
      jsonLabel: "",
      jsonValue: "",
      is_loading: false,
      hideSidebar: false,
      isSubmittingEnquiry: false,
      isSubmittingDetails: false,
    };
    this.handleEnquirySubmit = this.handleEnquirySubmit.bind(this);
    this.handleDetailsSubmit = this.handleDetailsSubmit.bind(this);

    this.appendData = this.appendData.bind(this);
    this.removeEnquiryData = this.removeEnquiryData.bind(this);
    this.setEnquiryJson = this.setEnquiryJson.bind(this);

    this.appendDetailsData = this.appendDetailsData.bind(this);
    this.removeDetailsData = this.removeDetailsData.bind(this);
    this.setDetailsJson = this.setDetailsJson.bind(this);
  }

  componentDidMount() {
    this.loadAuction();
  }

  async loadAuction() {
    this.setState({ is_loading: true });
    let id = this.state.auctionId;
    const response = await getAuction(id);
    let auction = response.data;
    if (auction) {
      let enquiry = auction.enquiry;
      if (enquiry && enquiry.length) {
        this.setState({ enquiries: enquiry });
      }

      let details = auction.details;
      if (details && details.length) {
        this.setState({ details: details });
      }
      this.setState({ is_loading: false });
    }
  }

  handleEnquirySubmit = async (event) => {
    event.preventDefault();
    try {
      this.setState({ isSubmittingEnquiry: true });
      let payload = this.state.input;
      payload.is_enquiry_update = true;
      payload.enquiries = this.state.enquiries;
      let id = this.state.auctionId;
      const response = await updateAuction(payload, id);
      if (response && response.data && response.data.id) {
        swal(i18n.t("success"), response.message, "success", {
          buttons: false,
          timer: 2000,
        }).catch((response) => {
          swal("Failed", response.message, "error");
        });
      } else {
        let error_message = "Not found!!!";
        let error_messages = response.message;
        for (const key in error_messages) {
          if (Object.hasOwnProperty.call(error_messages, key)) {
            let element = error_messages[key];
            error_message += "\n" + element;
          }
        }
        swal("Failed", error_message, "error");
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isSubmittingEnquiry: false });
    }
  };

  handleDetailsSubmit = async (event) => {
    event.preventDefault();
    try {
      this.setState({ isSubmittingDetails: true });
      let payload = this.state.input;
      payload.is_details_update = true;
      payload.details = this.state.details;
      let id = this.state.auctionId;
      const response = await updateAuction(payload, id);
      if (response && response.data && response.data.id) {
        swal(i18n.t("success"), response.message, "success", {
          buttons: false,
          timer: 2000,
        }).catch((response) => {
          swal("Failed", response.message, "error");
        });
      } else {
        let error_message = "Not found!!!";
        let error_messages = response.message;
        for (const key in error_messages) {
          if (Object.hasOwnProperty.call(error_messages, key)) {
            let element = error_messages[key];
            error_message += "\n" + element;
          }
        }
        swal("Failed", error_message, "error");
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isSubmittingDetails: false });
    }
  };

  appendData(e) {
    e.preventDefault();
    let enquiries = this.state.enquiries || [];
    enquiries.push({ label: "", value: "" });
    this.setState({ enquiries: enquiries });
  }

  removeEnquiryData(key) {
    let enquiries = this.state.enquiries;
    delete enquiries[key];
    this.setState({ enquiries: enquiries });
  }

  setEnquiryJson(key, event, arrKey) {
    let enquiries = this.state.enquiries;
    enquiries[arrKey][key] = event.target.value;
    this.setState({ enquiries: enquiries });
  }

  appendDetailsData(e) {
    e.preventDefault();
    let details = this.state.details || [];
    details.push({ label: "", value: "" });
    this.setState({ details: details });
  }

  removeDetailsData(key) {
    let details = this.state.details;
    delete details[key];
    this.setState({ details: details });
  }

  setDetailsJson(key, event, arrKey) {
    let details = this.state.details;
    details[arrKey][key] = event.target.value;
    this.setState({ details: details });
  }

  render() {
    let enquiries = this.state.enquiries;
    let details = this.state.details;

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t("enquiry") + " & " + i18n.t("details")}
          subtitle={i18n.t("manage_enquiry_details_subtitle") || "Manage auction enquiries and details"}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{
                          fontSize: "1rem",
                          marginRight: "0.5rem",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          })
                        }
                      >
                        {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                        {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                      </span>
                    </div>
                    <div className="header-action">
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() => window.history.back()}
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t("back")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <AuctionTabs activeTab="enquiry" />
                    <div className="create-group-container">
                      <div className="form-content" style={{ flexDirection: "column" }}>

                        {/* Loading State */}
                        {this.state.is_loading && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "3rem",
                              background: "#f9fafb",
                              borderRadius: "8px",
                            }}
                          >
                            <Loader2
                              className="animate-spin"
                              size={24}
                              style={{ marginRight: "8px" }}
                            />
                            <span>{i18n.t("loading") || "Loading..."}</span>
                          </div>
                        )}

                        {!this.state.is_loading && (
                          <>
                            {/* ENQUIRY SECTION */}
                            <div className="form-section">
                              <div className="section-header">
                                <h2>{i18n.t("enquiry")}</h2>
                                <button
                                  className="button1 button1-secondary"
                                  onClick={this.appendData}
                                  type="button"
                                >
                                  <Plus size={18} /> {i18n.t("add_new")}
                                </button>
                              </div>

                              {enquiries &&
                                enquiries.length > 0 &&
                                enquiries.map((item, i) => {
                                  if (!item) return null;
                                  return (
                                    <div key={i} className="enquiry-item">
                                      <div className="form-row">
                                        <div className="form-field">
                                          <label>{i18n.t("label")}</label>
                                          <input
                                            type="text"
                                            placeholder={i18n.t("label")}
                                            value={item.label || ""}
                                            onChange={(event) => {
                                              this.setEnquiryJson("label", event, i);
                                            }}
                                          />
                                        </div>
                                        <div className="form-field">
                                          <label>{i18n.t("value")}</label>
                                          <input
                                            type="text"
                                            placeholder={i18n.t("value")}
                                            value={item.value || ""}
                                            onChange={(event) => {
                                              this.setEnquiryJson("value", event, i);
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <div className="form-row">
                                        <div className="form-field">
                                          <label>{i18n.t("label_ar")}</label>
                                          <input
                                            type="text"
                                            placeholder={i18n.t("label_ar")}
                                            value={item.label_ar || ""}
                                            dir="rtl"
                                            onChange={(event) => {
                                              this.setEnquiryJson("label_ar", event, i);
                                            }}
                                          />
                                        </div>
                                        <div className="form-field">
                                          <label>{i18n.t("value_ar")}</label>
                                          <input
                                            type="text"
                                            placeholder={i18n.t("value_ar")}
                                            value={item.value_ar || ""}
                                            dir="rtl"
                                            onChange={(event) => {
                                              this.setEnquiryJson("value_ar", event, i);
                                            }}
                                          />
                                        </div>
                                      </div>
                                      {i > 0 && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <button
                                            className="button1 button1-danger"
                                            onClick={() => {
                                              this.removeEnquiryData(i);
                                            }}
                                            type="button"
                                          >
                                            <Trash2 size={18} />
                                            {i18n.t("remove")}
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}

                              <div className="action-buttons-l2 border-top-light">
                                <button
                                  className="button1 button1-gray"
                                  onClick={() => window.history.back()}
                                  type="button"
                                  disabled={this.state.isSubmittingEnquiry}
                                >
                                  {i18n.t("cancel")}
                                </button>
                                <button
                                  className="button1 button1-primary"
                                  onClick={this.handleEnquirySubmit}
                                  type="button"
                                  disabled={this.state.isSubmittingEnquiry}
                                >
                                  {this.state.isSubmittingEnquiry ? (
                                    <>
                                      <Loader2 className="animate-spin" size={18} />
                                      <span>{i18n.t("update")}</span>
                                    </>
                                  ) : (
                                    <span>{i18n.t("update")} {i18n.t("enquiry")}</span>
                                  )}
                                </button>
                              </div>
                            </div>

                            {/* DETAILS SECTION */}
                            <div className="form-section" style={{ marginTop: "24px" }}>
                              <div className="section-header">
                                <h2>{i18n.t("details")}</h2>
                                <button
                                  className="button1 button1-secondary"
                                  onClick={this.appendDetailsData}
                                  type="button"
                                >
                                  <Plus size={18} /> {i18n.t("add_new")}
                                </button>
                              </div>

                              {details &&
                                details.length > 0 &&
                                details.map((item, i) => {
                                  if (!item) return null;
                                  return (
                                    <div key={i} className="enquiry-item">
                                      <div className="form-row">
                                        <div className="form-field">
                                          <label>{i18n.t("label")}</label>
                                          <input
                                            type="text"
                                            placeholder={i18n.t("label")}
                                            value={item.label || ""}
                                            onChange={(event) => {
                                              this.setDetailsJson("label", event, i);
                                            }}
                                          />
                                        </div>
                                        <div className="form-field">
                                          <label>{i18n.t("value")}</label>
                                          <input
                                            type="text"
                                            placeholder={i18n.t("value")}
                                            value={item.value || ""}
                                            onChange={(event) => {
                                              this.setDetailsJson("value", event, i);
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <div className="form-row">
                                        <div className="form-field">
                                          <label>{i18n.t("label_ar")}</label>
                                          <input
                                            type="text"
                                            placeholder={i18n.t("label_ar")}
                                            value={item.label_ar || ""}
                                            dir="rtl"
                                            onChange={(event) => {
                                              this.setDetailsJson("label_ar", event, i);
                                            }}
                                          />
                                        </div>
                                        <div className="form-field">
                                          <label>{i18n.t("value_ar")}</label>
                                          <input
                                            type="text"
                                            placeholder={i18n.t("value_ar")}
                                            value={item.value_ar || ""}
                                            dir="rtl"
                                            onChange={(event) => {
                                              this.setDetailsJson("value_ar", event, i);
                                            }}
                                          />
                                        </div>
                                      </div>
                                      {i > 0 && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <button
                                            className="button1 button1-danger"
                                            onClick={() => {
                                              this.removeDetailsData(i);
                                            }}
                                            type="button"
                                          >
                                            <Trash2 size={18} />
                                            {i18n.t("remove")}
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}

                              <div className="action-buttons-l2 border-top-light">
                                <button
                                  className="button1 button1-gray"
                                  onClick={() => window.history.back()}
                                  type="button"
                                  disabled={this.state.isSubmittingDetails}
                                >
                                  {i18n.t("cancel")}
                                </button>
                                <button
                                  className="button1 button1-primary"
                                  onClick={this.handleDetailsSubmit}
                                  type="button"
                                  disabled={this.state.isSubmittingDetails}
                                >
                                  {this.state.isSubmittingDetails ? (
                                    <>
                                      <Loader2 className="animate-spin" size={18} />
                                      <span>{i18n.t("update")}</span>
                                    </>
                                  ) : (
                                    <span>{i18n.t("update")} {i18n.t("details")}</span>
                                  )}
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}